import useGameToastMessages from '@/src/hooks/data/useGameToastMessages'
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearToastMessages } from '@/Poker/redux/slices/gameTableSlice';
import { showToast } from '@/Poker/utils/toastUtils';


export default function GameToastProvider({ children, tempTableId }) {
    const toastMessages = useGameToastMessages(tempTableId);
    const dispatch = useDispatch();

    useEffect(() => {
        //    Pop the latest toast message
        if (toastMessages.length > 0) {
            let latestToastMessage = toastMessages[toastMessages.length - 1];
            showToast(
                latestToastMessage.type,
                latestToastMessage.title || '',
                latestToastMessage.message || ''
            );
            dispatch(clearToastMessages({ tempTableId }));
        }
    }, [toastMessages]);

    return children
}
